import React, { useRef, useState, useEffect } from 'react';

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Cta from "../components/CtaWebsite";

import "../styles/common.css";
import "../styles/service.css";

import imgIssue01 from "../img/website/illustration_website_01.svg";
import imgIssue02 from "../img/website/illustration_website_02.svg";
import imgIssue03 from "../img/website/illustration_website_03.svg";
import imgIssue04 from "../img/website/illustration_website_04.svg";
import imgfeature01 from "../img/website/img_feature_01.png";
import imgfeature02 from "../img/website/img_feature_02.png";
import imgfeature03 from "../img/website/img_feature_03.png";
import imgSupport01 from "../img/website/img_support_01.png";
import imgSupport02 from "../img/website/img_support_02.png";
import imgSupport03 from "../img/website/img_support_03.png";

const WebSite = () => {

  return (
    <>
      <Navbar></Navbar>
      <main className='website'>
        <section className='fvUnder'>
          <div className='fvUnder-text'>
            <h1>Webサイト制作</h1>
            <nav aria-label="Breadcrumb" className="breadcrumb">
              <ol className='breadcrumb'>
                <li><a href="/">Home</a></li>
                <li aria-current="page">Webサイト制作</li>
              </ol>
            </nav>
          </div>
        </section>
        <section className='issue'>
          <div className="title">
            <p className='title-lead'>ISSUE</p>
            <h2>このような課題を解決します</h2>
          </div>
          <div className='flexBox-bkWhite issue-box'>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue01} alt="" />
              </div>
              <h3>ヨーロッパにおける企業イメージを高めたい</h3>
            </div>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue02} alt="" />
              </div>
              <h3>製品・企業の強みを分かりやすく伝えたい</h3>
            </div>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue03} alt="" />
              </div>
              <h3>Web経由の問い合わせ獲得を目指したい</h3>
            </div>
            <div className='issue-box__item'>
              <div className='issue-item__image'>
                <img src={imgIssue04} alt="" />
              </div>
              <h3>ECで商品販売をしたい</h3>
            </div>
          </div>
          <div className='issue-text'>
          <p>LOGOTは問題への解決に寄り添い<br /><span>”存在感”を最大化</span>する<br className='sp-only'/><span>Webサイト</span>を制作します。</p>
          </div>
        </section>
        <section className='feature'>
          <div className="title">
            <p className='title-lead'>FEATURE</p>
            <h2>LOGOTが制作するWebサイトの特長</h2>
          </div>
          <div className='feature-box flexBox-imgText'>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>01</span></p>
                <h3>多様な決済・自由な商品登録のECサイト構築が可能</h3>
                <p className='feature-item__detail'>オンラインショップの成功には、自由度の高いECサイトの構築が欠かせません。<br />LOGOTが手がけるECサイトは、商品数の制限なく、スケールに応じた柔軟な対応が可能です。<br />また、決済システムの多様化にも対応し、Shopifyを活用したECサイト構築もサポートいたします。</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature01} alt="" />
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature02} alt="" />
              </div>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>02</span></p>
                <h3>柔軟なECサイト構築で、ビジネスの可能性を最大化</h3>
                <p className='feature-item__detail'>Webサイトデザインは、企業の第一印象を左右します。そのため、お問い合わせ獲得数にも大きな影響をもたらします。<br />LOGOTが制作するWebサイトはご要望に応じてスタイリッシュやユニーク・トレンド感を創出しながら、ターゲット層に響く「競合に勝つデザイン」をご提案します。</p>
              </div>
            </div>
            <div className='flexBox-imgText__item feature-box__item'>
              <div className='flexBox-imgText__text feature-item__text'>
                <p className='feature-item__number text-green'>Feature<span>03</span></p>
                <h3>ローカライズ言語対応を踏まえた制作</h3>
                <p className='feature-item__detail'>ヨーロッパ市場への進出や拡大において、言語の壁は最大の課題の一つです。<br />LOGOTでは多言語にも対応できるWebサイト制作が可能です。</p>
              </div>
              <div className='flexBox-imgText__image feature-item__image'>
                <img src={imgfeature03} alt="" />
              </div>
            </div>
          </div>
        </section>
        <Cta></Cta>
        <section className='flow'>
          <div className="title">
            <p className='title-lead'>FLOW</p>
            <h2>コーポレイト制作の流れ</h2>
          </div>
          <ol className='flow-box'>
            <li>
              <div className='flow-box__number'><p>1</p></div>
              <div className='flow-box__text'>
                <h3>無料相談（Zoomもしくは対面）</h3>
                <p>事業内容や経営状況、Webサイト制作の目的、ご予算についてお聞きします。初めてWebサイト制作をお考えの方には、専門用語を使わず、わかりやすい説明を心がけます。既存サイトのリニューアルをお考えのお客様も歓迎です。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>2</p></div>
              <div className='flow-box__text'>
                <h3>お見積もりの提出</h3>
                <p>お見積もりの提出ヒアリングの内容をもとに、Webサイトによる貴社のブランディング戦略を検討。Webサイトの構成案をもとにお見積もりを作成いたします。ブランディング支援やコーポレートロゴ制作なども承ります。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>3</p></div>
              <div className='flow-box__text'>
                <h3>ご契約</h3>
                <p>お見積もりをお渡しします。ご不明点や疑問点があれば、営業にご質問ください。それぞれの項目の詳細までしっかりと説明いたします。内容にご納得いただけたら、電子契約を通じて正式なご契約となります。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>4</p></div>
              <div className='flow-box__text'>
                <h3>キックオフミーティング</h3>
                <p>Webサイトの制作方針やコンセプトの共有を目的とした打ち合わせを実施します。お客様の会社概要や商品情報、商材の強みなどを深掘りしつつ、貴社と当社のサイトのイメージを一致させます。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>5</p></div>
              <div className='flow-box__text'>
                <h3>制作開始</h3>
                <p>キックオフミーティングでお聞きしたご意見とご要望を踏まえて、Webサイト制作を開始します。原稿作成時に必要となる資料・情報のご提供からご協力いただきます。</p>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>6</p></div>
              <div className='flow-box__text'>
                <h3>制作経過のご報告</h3>
                <p>制作開始後は、以下のタイミングにて制作経過をご報告します。</p>
                <ol className='list-cercleNumber'>
                  <li>
                    <span>&#9312;</span>
                    <h4>TOPデザイン案の提出</h4>
                    <p>TOPページのファーストビューを中心としたデザインをご提案。サイト全体のデザイン方針のすり合わせとなります。</p>
                  </li>
                  <li>
                    <span>&#9313;</span>
                    <h4>テストサイト（PC）の提出</h4>
                    <p>TOPページデザインをもとに、サイト全体を構築。文章や動き、イラストなども一緒に確認いただきます。</p>
                  </li>
                  <li>
                    <span>&#9314;</span>
                    <h4>テストサイト（スマートフォン）の提出</h4>
                    <p>PC版サイトをもとにスマートフォン版のサイトを構築。修正やご要望は、担当者までお知らせください。</p>
                  </li>
                </ol>
              </div>
            </li>
            <li>
              <div className='flow-box__number'><p>7</p></div>
              <div className='flow-box__text'>
                <h3>納品（本番公開）</h3>
                <p>品質管理チームによるWebサイト全体のダブルチェックを実施。文章面、デザイン面、動きや動線などを中心として入念に確認後、本番公開となります。サイト公開後1週間は、文字修正などの軽微な修正は無償で対応します。</p>
              </div>
            </li>
          </ol>
        </section>
        <section className='support'>
          <div className="title">
            <p className='title-lead'>SUPPORTS</p>
            <h2>公開後の運用サポートについて</h2>
          </div>
          <div className='support-text'>
            <p>公開で終わらない、<br className='sp-only'/>コーポレイトサイト！</p>
          </div>
          <div className='flexBox-bkWhite support-box'>
            <div className='support-box__item'>
              <div className='support-item__image'>
                <img src={imgSupport01} alt="" />
              </div>
              <div className='support-item__text'>
                <h3>Webサイト運用をまるっとお任せ!</h3>
                <p>ターゲット市場に最適な戦略で、売上拡大とブランドの認知向上をサポート。<br />SEO対策・SNS運用・広告運用・問い合わせ獲得施策などを通じて、ヨーロッパ市場でのWeb集客を加速させます。</p>
              </div>
              <div className='button-content button-arrow button-black'>
                <a href="/marketing">詳しくみる</a>
              </div>
            </div>
            <div className='support-box__item'>
              <div className='support-item__image'>
                <img src={imgSupport02} alt="" />
              </div>
              <div className='support-item__text'>
                <h3>企業の印象は「ブランディング」で決まる時代</h3>
                <p>戦略策定からビジュアルデザイン、コンテンツ制作、データ分析に至るまで、貴社のブランド価値を最大限に引き出すトータルブランディング支援を提供します。<br />市場の変化に対応しながら、長期的にブランド価値を高めるために、LOGOTが継続的にサポートします。</p>
              </div>
              <div className='button-content button-arrow button-black'>
                <a href="/branding">詳しくみる</a>
              </div>
            </div>
            <div className='support-box__item'>
              <div className='support-item__image'>
                <img src={imgSupport03} alt="" />
              </div>
              <div className='support-item__text'>
                <h3>コンサルティングで継続的にサポート！「カスタマーサクセス（保守・運用支援）」</h3>
                <p>更新方法に関する質問対応から、アクセスデータを元にした定期的な戦略コンサルティングなど、「Web集客の成功」をお手伝いします。</p>
              </div>
              <div className='button-content button-arrow button-black'>
                <a href="/branding">詳しくみる</a>
              </div>
            </div>
          </div>
        </section>
        <Cta></Cta>
      </main >
      <Footer></Footer>
    </>
  );
};

export default WebSite